import {
  SYSTEM_SETTING_KEY,
  SystemSetting,
} from "../../../../types/system-setting.type";
import { findTextSetting } from "../../../../utils/hooks/useSystemSettings";

/**
 * The books the system settings name are priced by the platform: the face-price book changes only
 * through each product's ราคาหน้าซอง, and the API refuses to rewrite the sales default's lines —
 * so neither is edited here nor copied as a draft (applying one replaces the whole line set).
 */
export type ReservedBookKind = "face_price" | "sales_default";

export const findReservedBookKind = (
  settings: SystemSetting[],
  code: string,
): ReservedBookKind | null => {
  if (findTextSetting(settings, SYSTEM_SETTING_KEY.pricebookFacePriceCode) === code) {
    return "face_price";
  }
  if (findTextSetting(settings, SYSTEM_SETTING_KEY.pricebookSalesDefaultCode) === code) {
    return "sales_default";
  }
  return null;
};
